// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__bkDD0","title":"AfterBackImages_title__oZl5K","images":"AfterBackImages_images__rSIWv"};